/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { formatDateTimeBr } from '../../utils/format';

// ---------------------------------------------------------------------------
// Resultado do "Testar conexão", inline no card da credencial (handoff 0079 §3.3).
//
// ⚠️ Quem decide o resultado é `test.ok`, NÃO o status HTTP: uma chave recusada
// devolve 200 com ok:false e o motivo. O teste rodou — só deu negativo. Erros de
// verdade (404/5xx) nem chegam aqui: sobem para o catch da página.
// ---------------------------------------------------------------------------

const Box = styled.div`
   margin-top: 10px;
   border-radius: 10px;
   padding: 10px 12px;
   font-size: 12.5px;
   line-height: 1.5;
   border: 1px solid
      ${({ $ok }) => ($ok ? 'rgba(46,125,50,0.4)' : 'rgba(171,32,32,0.4)')};
   background: ${({ $ok }) =>
      $ok ? 'rgba(46,125,50,0.08)' : 'rgba(171,32,32,0.07)'};
   color: ${({ $ok }) => ($ok ? '#1b5e20' : '#8a1f1f')};

   .headline {
      font-weight: 800;
      display: flex;
      align-items: center;
      gap: 6px;
      flex-wrap: wrap;
   }

   .detail {
      margin-top: 4px;
   }

   .stamp {
      margin-top: 4px;
      font-size: 11.5px;
      opacity: 0.8;
   }
`;

export default function ConnectionTestResult({ test }) {
   if (!test) return null;

   const ok = test.ok === true;

   return (
      <Box $ok={ok}>
         <div className="headline">
            {ok
               ? '✓ Conexão bem-sucedida'
               : `✕ Falha na conexão${
                    test.status_code ? ` (HTTP ${test.status_code})` : ''
                 }`}
         </div>
         {!ok && test.message && <div className="detail">{test.message}</div>}
         {ok && (
            <div className="detail">
               A chave autenticou no provedor e está apta a emitir.
            </div>
         )}
         <div className="stamp">
            Testado em {formatDateTimeBr(test.checked_at)}
         </div>
      </Box>
   );
}

ConnectionTestResult.propTypes = {
   test: PropTypes.shape({
      ok: PropTypes.bool,
      status_code: PropTypes.number,
      message: PropTypes.string,
      checked_at: PropTypes.string,
   }),
};
